import React, { Component } from 'react';
import { Box, InputBase, Typography } from '@mui/material';

export class ProductPriceInput extends Component {
    constructor(props) {
        super(props);

        this.lastValidValue =
            props.initialValue != null
                ? props.initialValue
                : props.minPrice != null
                    ? props.minPrice.toFixed(2).toString().replace('.', ',')
                    : '0';
    }

    onEndEditing = () => {
        const { disabled, value, minPrice, maxPrice, setValue } = this.props;

        if (disabled) {
            return;
        }

        if (value != null && !isNaN(parseFloat(String(value).replace(',', '.')))) {
            const numericValue = parseFloat(String(value).replace(',', '.'));

            if (numericValue > 0) {
                if (minPrice != null && numericValue < minPrice) {
                    setValue?.(minPrice.toFixed(2).toString().replace('.', ','), true);
                    window.alert(`Bitte einen Wert zwischen ${minPrice} und ${maxPrice} eingeben.`);
                    return;
                } else if (maxPrice != null && numericValue > maxPrice) {
                    setValue?.(maxPrice.toFixed(2).toString().replace('.', ','), true);
                    window.alert(`Bitte einen Wert zwischen ${minPrice} und ${maxPrice} eingeben.`);
                    return;
                }

                this.lastValidValue = numericValue.toFixed(2).toString().replace('.', ',');
                setValue?.(this.lastValidValue, true);
            } else {
                window.alert('Es sind nur positive Zahlen erlaubt.');
                setValue?.(this.lastValidValue, true);
            }
        } else {
            setValue?.(this.lastValidValue, true);
        }
    };

    render() {
        const {
            maxLength,
            labelFlex,
            label,
            value,
            setValue,
            disabled,
            style,
        } = this.props;

        return (
            <Box
                sx={{
                    flex: 1,
                    minHeight: 40,
                    display: 'flex',
                    alignItems: 'stretch',
                    border: '1px solid rgba(211,211,211,0.91)',
                    borderRadius: '6px',
                    overflow: 'hidden',
                    ...style,
                }}
            >
                <Box
                    sx={{
                        flex: labelFlex || 1,
                        backgroundColor: '#F3F3F3',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        px: 1.5,
                    }}
                >
                    <Typography
                        sx={{
                            textAlign: 'center',
                            fontSize: 14,
                            color: '#676767',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {label != null ? label : 'Preis'}:
                    </Typography>
                </Box>

                <Box
                    sx={{
                        flex: 2,
                        borderLeft: '1px solid rgba(211,211,211,0.91)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        px: 1.5,
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        <InputBase
                            fullWidth
                            // disabled={disabled}
                            inputRef={(ref) => {
                                this.productNameRef = ref;
                            }}
                            inputProps={{
                                maxLength: maxLength ?? 6,
                                inputMode: 'decimal',
                            }}
                            onFocus={() => {
                                if (disabled) {
                                    this.productNameRef.blur();
                                }
                                setValue?.('');
                            }}
                            onBlur={this.onEndEditing}
                            value={value?.toString().replace('.', ',') ?? ''}
                            onChange={(e) => {
                                setValue?.(e.target.value);
                            }}
                            sx={{
                                flex: 3,
                                fontSize: 14,
                                color: '#F19135',
                                fontWeight: 'bold',
                                fontStyle: 'italic',
                                textAlign: 'right',
                                '& input': {
                                    textAlign: 'right',
                                    color: '#F19135',
                                    fontWeight: 'bold',
                                    fontStyle: 'italic',
                                },
                            }}
                        />

                        <Typography
                            sx={{
                                flex: 1,
                                fontSize: 14,
                                color: '#F19135',
                                fontWeight: 'bold',
                                fontStyle: 'italic',
                                textAlign: 'left',
                                pl: 1,
                                whiteSpace: 'nowrap',
                            }}
                        >
                            €
                        </Typography>
                    </Box>
                </Box>
            </Box>
        );
    }
}

export default ProductPriceInput;